const initSlickJs = (selector) => {
  $("[data-slick]").not(".slick-initialized").slick();
};
export default initSlickJs;
